export const CLEAR_PROJECTS_DATA = 'CLEAR_PROJECTS_DATA';
export const CLEAR_SUCCESS_FLAG = 'CLEAR_SUCCESS_FLAG';
